import type { OrderedMap } from 'immutable';
import { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { getPayeesForTransactions } from './payeesSelectors';

export function useSearchablePayees() {
  const [searchText, setSearchText] = useState('');

  const payees: OrderedMap<string, string> = useSelector(getPayeesForTransactions);

  const trimmedSearchText = searchText?.trim().toLowerCase();

  const filteredPayees = useMemo(() => {
    let payeeData = payees;

    if (trimmedSearchText) {
      payeeData = payeeData.filter((payee) => payee?.toLowerCase().includes(trimmedSearchText));
    }

    return payeeData
      .toList()
      .toArray()
      .sort((a, b) => a.localeCompare(b));
  }, [payees, trimmedSearchText]);

  return {
    payees,
    filteredPayees,
    searchText,
    setSearchText,
    trimmedSearchText,
  };
}
